import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Pagination from '../../../../../components/Shared/Pagination/Pagination.jsx';
import useLookupModule from '../../../../../hooks/Lookups/use-Lookup-Module';
import { Card, CardBody } from '../../../../../components/card/card';
import { useAppDispatch, useAppSelector } from '../../../../../store/hooks';
import { GetReportsList } from '../../../../../store/NTX/Reports/reportSlice';
import Breadcrumb from '../../../../../components/Shared/Breadcrumb';
import { usePermissions } from '../../../../../Helper/Permisstions/usePermissions';
import Loading from '../../../../../components/Shared/Loader/Loading';
import NeatixModal from '../../../../../components/Modal/NeatixModal.jsx';
import NtxTable from '../../../../../components/DataTable/NtxTable.jsx';
import MngTemplates from '../../PrintingForms/MngTemplates';
import Select from 'react-select';

interface Report {
  id: string;
  name: string;
  name2: string;
  moduleId: string;
  moduleName: string;
  moduleName2: string;
  tableName: string;
  icon: string;
  reportSourceName: string;
  reportSourceName2: string;
  // query: string;
  // description: string;
  // pageType: string;
  // reportType: string;
}

interface ReportsListState {
  ReportsList: Report[];
  loading: boolean;
  // Add any other properties you have in the ReportsList
}

interface LookupModule {
  Module: any[];
}

function Index() {
  const { HasPermission } = usePermissions();
  const { t, i18n } = useTranslation();
  const [search, setSearch] = useState<string>('');
  const Navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [templateId, setTemplateId] = useState<string>('');
  const [show, setShow] = useState(false);

  //__________________________________________________
  const { ReportsList, loading } = useAppSelector(state => state.Reports) as ReportsListState;
  useEffect(() => {
    if (ReportsList?.length === 0) {
      dispatch(GetReportsList());
    }
  }, [dispatch]);

  //_____________________________________________________

  const [selectedValue, setSelectedValue] = useState(null);
  const { OptionsModule } = useLookupModule();

  //_________________________________________________________________________________________________

  const filteredSearch = ReportsList?.slice()
    ?.filter(item => {
      const searchLowerCase = search.toLowerCase();
      return (
        item.tableName?.toLowerCase().includes(searchLowerCase) ||
        item.name?.toLowerCase().includes(searchLowerCase) ||
        item.name2?.toLowerCase().toString().includes(searchLowerCase)
      );
    })
    ?.filter(f => (selectedValue === null ? true : f.moduleId === selectedValue));

  //____________________________

  const columns = [
    { title: t('Reports_Name'), key: 'Name' },
    { title: t('Data_Source'), key: 'Source' },
    { title: t('Application'), key: 'app' },
    { title: t('Icon'), key: 'icon', className: '' },
    { title: t(''), key: 'action', className: 'text-end' }
  ];

  const tableData = filteredSearch?.map(item => {
    let rowClass;

    return {
      Name: i18n.language === 'en' ? item.name : item.name2,
      Source: i18n.language === 'en' ? item.reportSourceName : item.reportSourceName2,
      app: i18n.language === 'en' ? item.moduleName : item.moduleName2,
      icon: (
        <div className='text-theme fs-4'>
          <i className={item.icon}></i>
        </div>
      ),
      action: (
        <div className='btn-group'>
          {HasPermission('NtxReportCharts') && (
            <button
              type='button'
              onClick={() => Navigate(`/RPT/Reports/${item.id}/AddReportShape`)}
              className='btn btn-outline-theme '
            >
              <i className='fa-lg fa-fw me-1 bi bi-bar-chart-line'></i>
              {t('Charts_Report')}
            </button>
          )}

          {HasPermission('NtxEditReport') && (
            <>
              <button
                type='button'
                className='btn  btn-outline-theme '
                onClick={() => {
                  const newLocation = `/RPT/Reports/${item.id}/UpdateReport`;
                  window.location.href = newLocation;
                }}
              >
                <i className='far fa-lg fa-fw me-1 fa-edit'></i>
                {t('Edit_Reports')}
              </button>
              <button
                type='button'
                className='btn  btn-outline-theme '
                onClick={() => {
                  setTemplateId(item.id);
                  setShow(true);
                }}
              >
                <i className='  fa-lg fa-fw me-1 bi bi-file-earmark-text'></i>
                {t('إعدادت القالب')}
              </button>
            </>
          )}
        </div>
      ),

      rowClass // استخدم rowClass هنا
    };
  });

  //____________________________
  return (
    <>
      <div className='d-flex align-items-center'>
        <Breadcrumb
          BreadcrumbList={[
            {
              name: 'Home',
              link: ':moduleHome'
            },
            {
              name: t('Reports'),
              link: null
            }
          ]}
          PageName={t('Reports_Management')}
        />

        <div className='ms-auto'>
          {HasPermission('NtxAddReport') && (
            <button className='btn btn-theme' onClick={() => Navigate(`/RPT/Reports/AddReport`)}>
              <i className='fa fa-plus-circle fa-fw me-1'></i>
              {t('Add_Reports')}
            </button>
          )}
        </div>
      </div>
      <Card>
        <Loading loading={loading}>
          <CardBody>
            <div className='row'>
              <div className='col-xl-6'>
                <div className='input-group flex-nowrap mb-2'>
                  <span className='input-group-text'>{t('Application')}</span>
                  <Select
                    classNamePrefix='react-select'
                    className='w-100'
                    // isLoading={loading2}
                    isSearchable={true}
                    isClearable
                    options={OptionsModule?.filter((f: any) => ReportsList?.some(item => item.moduleId === f.value))}
                    onChange={(option: any) => {
                      setSelectedValue(option === null ? null : option.value);
                    }}
                    placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                  />
                </div>
              </div>
              <div className='col-xl-6'>
                <div className='input-group flex-nowrap mb-2'>
                  <span className='input-group-text'>{t('Search')}</span>
                  <input
                    type='text'
                    autoComplete='off'
                    className='form-control '
                    onChange={e => {
                      setSearch(e.target.value);
                    }}
                  />
                </div>
              </div>
            </div>

            <NtxTable
              data={tableData || []}
              columns={columns}
              dataPerPage={10}
              theadClass=''
              tableClass='table text-nowrap table-hover '
            />
          </CardBody>
        </Loading>
      </Card>

      <NeatixModal show={show} setShow={setShow} size='xl' bodyClassName='p-2' showHeader={false}>
        {templateId && <MngTemplates templateId={templateId} onClose={() => setShow(false)} />}
      </NeatixModal>
    </>
  );
}

export default Index;
